export default __webpack_public_path__ + "static/ThinkstockPhotos-510676766_article-3cb50997d4ef48f67d0fbdc796518cac.jpg";